import Svg, { SvgProps, Path } from 'react-native-svg';

const WaitIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M7.984 2.986A1 1 0 0 0 7.84 3H6a1 1 0 1 0 0 2h1v2c0 4.612 3.112 7.053 4.465 8C10.112 15.947 7 18.388 7 23v2H6a1 1 0 1 0 0 2h1.832a1 1 0 0 0 .326 0h13.674a1 1 0 0 0 .326 0H24a1 1 0 1 0 0-2h-1v-2c0-4.612-3.112-7.053-4.465-8C19.888 14.053 23 11.612 23 7V5h1a1 1 0 1 0 0-2h-1.846a1 1 0 0 0-.17-.014A1 1 0 0 0 21.84 3H8.154a1 1 0 0 0-.17-.014zM9.09 8h11.82c-.608 3.759-4.424 6.143-4.424 6.143a1 1 0 0 0 0 1.714S20.302 18.241 20.91 22h-2.053A3.99 3.99 0 0 0 15 19a3.99 3.99 0 0 0-3.857 3H9.09c.608-3.759 4.424-6.143 4.424-6.143a1 1 0 0 0 0-1.714S9.698 11.759 9.09 8z" />
  </Svg>
);

export default WaitIcon;
